<template>
  <div id="wrapper">
    <div id="header">
      <img :src="require('@/assets/img/logo/full_logo.png')" class="full-logo" />
    </div>
    <div id="main-wrapper">
      <div id="main">
        <img :src="require('@/assets/img/login/login_title.png')" class="login-title" />
        <div class="row-block">
          <el-input placeholder="请输入账号" prefix-icon="el-icon-user" v-model="loginForm.userName"></el-input>
        </div>
        <div class="row-block">
          <el-input
            :type="showLoginPassword ? 'text' : 'password'"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            v-model="loginForm.password">
            <i
              slot="suffix"
              :class="[showLoginPassword ? 'ri-eye-line' : 'ri-eye-close-line']"
              @click="showLoginPassword = !showLoginPassword"></i>
          </el-input>
        </div>
        <div class="row-block">
          <el-button type="primary" @click="handelLogin">登录</el-button>
        </div>
      </div>
    </div>
    <div id="footer-wrapper">
      <layout-footer id="footer" />
    </div>

    <div class="page-dialog">
      <el-dialog :visible.sync="verify2FAView.visible" :close-on-click-modal="false" width="350px" class="verify-2FA">
        <div><img src="/static/img/security_auth.png" /></div>
        <h2>安全验证</h2>
        <div class="tip">为了保障您的账户安全，请完成身份验证</div>
        <div v-if="verify2FAView.isSend" class="send-tip">📱 验证码已发送至 {{ maskMobile }}</div>
        <div class="verify-code">
          <el-input
            placeholder="请输入6位验证码"
            maxlength="6"
            oninput="value = value.replace(/[^\d]/g, '')"
            v-model="verify2FAForm.verifyCode"></el-input>
          <el-button type="primary" :disabled="verify2FAView.isCountDown" @click="getVerifyCode">
            {{ verify2FAView.isCountDown ? verify2FAView.countDown + '秒后可重新获取' : '获取验证码' }}
          </el-button>
        </div>
        <el-button type="primary" :loading="verify2FAView.loading" @click="loginByTempToken">确认验证</el-button>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { encryptPassword, getDeviceInfo } from '@/utils/tool';
import { fetchPublicKey, sendVerifycode, doLogin, doLoginByTempToken } from '@/api/user';
import { checkPassword, checkMobile } from '@/utils/validate';
export default {
  data() {
    return {
      showLoginPassword: false,
      loginForm: {
        userName: '',
        password: '',
      },
      loading: false,
      redirect: null,
      verify2FAView: {
        visible: false,
        isSend: false,
        isCountDown: false,
        countDown: 60,
        loading: false,
      },
      verify2FAForm: {
        tempToken: '',
        mobile: '',
        verifyCode: '',
      },
    };
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute(
        'style',
        "background:url('/static/img/background.png') no-repeat;background-size:100% 100%;background-attachment:fixed;margin:0;",
      );
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = (route.query && route.query.redirect) || '/';
      },
      immediate: true,
    },
  },
  async mounted() {
    const deviceInfo = await getDeviceInfo();
    this.loginForm.deviceID = deviceInfo.deviceId;
    this.loginForm.deviceName = deviceInfo.deviceName;
    this.verify2FAForm.deviceID = deviceInfo.deviceId;
    this.verify2FAForm.deviceName = deviceInfo.deviceName;
  },
  computed: {
    maskMobile() {
      if (!this.verify2FAForm.mobile) {
        return '';
      }
      return this.verify2FAForm.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
  },
  methods: {
    async getVerifyCode() {
      const isVerify = this.verify2FAView.visible;
      await sendVerifycode({
        type: isVerify ? 2 : this.isLogin ? 0 : 1,
        mobile: this.verify2FAForm.mobile,
      });
      if (isVerify) {
        this.verify2FAForm.verifyCode = '';
        this.verify2FAView.isSend = true;
        this.verify2FAView.isCountDown = true;
        this.verify2FAView.countDown = 60;
      }
      this.countDown(isVerify, this.isLogin);
      this.$baseMessage('已发送验证码成功', 'success');
    },
    countDown(isVerify, isLogin) {
      setTimeout(() => {
        if (isVerify) {
          this.verify2FAView.countDown--;
          if (this.verify2FAView.countDown > 0) {
            this.countDown(isVerify, isLogin);
          } else {
            this.verify2FAView.isCountDown = false;
          }
        }
      }, 1000);
    },
    async handelLogin() {
      if (!this.loginForm.userName) {
        this.$baseMessage('用户名不可为空', 'error');
        return;
      }
      if (!this.loginForm.password) {
        this.$baseMessage('密码不可为空', 'error');
        return;
      }

      const pubKeyItem = await fetchPublicKey();
      this.loading = true;

      try {
        const res = await doLogin({
          KeyId: pubKeyItem.keyId,
          encryptedData: encryptPassword(this.loginForm.password, pubKeyItem.publicKey),
          userName: this.loginForm.userName,
          deviceID: this.loginForm.deviceID,
          deviceName: this.loginForm.deviceName,
        });

        if (res.data?.Require2FA ?? false) {
          this.verify2FAForm.tempToken = res.data.TempToken;
          this.verify2FAForm.mobile = res.data.Mobile;
          this.verify2FAView.visible = true;
          return;
        }
        if (res.data.token) {
          await this.$store.dispatch('user/setAccessToken', res.data.token);
          this.redirect = res.data.redirect ? res.data.redirect : 'home';
        } else {
          this.$baseMessage(`登录接口异常，未正确返回${res.msg}...`, 'error');
          return;
        }
        const routerPath = this.redirect === '/404' || this.redirect === '/401' ? '/' : this.redirect;
        this.$router.push(routerPath).catch(() => {});
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async loginByTempToken() {
      if (!this.verify2FAForm.mobile) {
        this.$baseMessage('手机号不能为空', 'error');
        return;
      }
      if (!checkMobile(this.verify2FAForm.mobile)) {
        this.$baseMessage('手机号格式不正确', 'error');
        return;
      }
      if (!this.verify2FAForm.verifyCode) {
        this.$baseMessage('验证码不能为空', 'error');
        return;
      }
      this.verify2FAView.loading = true;
      try {
        this.loading = true;
        const res = await doLoginByTempToken({ ...this.verify2FAForm });
        if (res.data.token) {
          await this.$store.dispatch('user/setAccessToken', res.data.token);
          this.redirect = res.data.redirect ? res.data.redirect : 'home';
        } else {
          this.$baseMessage(`登录接口异常，未正确返回${res.msg}...`, 'error');
          return;
        }
        const routerPath = this.redirect === '/404' || this.redirect === '/401' ? '/' : this.redirect;
        this.$router.push(routerPath).catch(() => {});
        this.loading = false;
      } finally {
        this.verify2FAView.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.verify-2FA {
  .el-dialog__header {
    min-height: 30px !important;
    padding-bottom: 0 !important;

    .el-icon-close {
      font-size: 20px !important;
    }

    .el-dialog__headerbtn:hover .el-dialog__close {
      color: #909399 !important;
    }
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: unset;
    padding: 0 20px 30px !important;

    h2 {
      margin-bottom: 6px;
    }

    .tip,
    .send-tip,
    .verify-code {
      margin-bottom: 25px;
    }

    .tip {
      font-size: 14px;
      color: #86909c;
    }

    .send-tip {
      width: 100%;
      padding: 12px 16px;
      background: #f7f8fa;
      border: 1px solid #e5e6eb;
      border-radius: 8px;
      box-sizing: border-box;
      color: #4e5969;
      font-size: 15px;
      text-align: center;
    }

    .verify-code {
      display: flex;
      flex-direction: row;

      .el-button {
        width: 150px !important;
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#wrapper {
  height: 100%;
  width: 100%;
  ::v-deep {
    .el-input--small .el-input__inner,
    .el-button {
      height: 40px !important;
      width: 100%;
      font-size: 14px;
    }

    .el-input__icon {
      font-size: 18px;
    }

    .el-input__suffix {
      line-height: 40px;
      cursor: pointer;

      i {
        font-size: 18px;
        opacity: 0.8;
        cursor: pointer;
      }
    }

    .el-dialog__body {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
    }

    .el-dialog__footer {
      text-align: center;

      .el-button {
        width: 300px;
      }
    }

    .el-link.el-link--default {
      color: white !important;
    }
  }
}

#header {
  height: 13%;
  min-height: 85px;
  position: relative;

  img {
    height: 52px;
    position: absolute;
    bottom: 0;
    left: 50px;
  }
}

#main-wrapper {
  height: 77%;
  min-height: 540px;
  position: relative;

  #main {
    height: 440px;
    width: 394px;
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -220px;
    margin-left: -197px;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 110px 20px 20px 20px;

    img {
      position: absolute;
      top: 0;
      left: 50%;
      width: 330px;
      height: 52px;
      margin-left: -165px;
    }

    .row-block {
      margin-bottom: 30px;
      width: 100%;

      &.end-block {
        text-align: right;
        margin-top: 28px;

        span {
          margin-left: 15px;
          cursor: pointer;
        }
      }
    }
  }
}

#footer-wrapper {
  height: 10%;
  min-height: 40px;
  position: relative;
  #footer {
    height: 40px;
    width: 100%;
    position: absolute;
    bottom: 0;
    color: white;
    line-height: 40px;
    text-align: center;
    background: rgba(0, 0, 0, 0.08);

    ::v-deep {
      a {
        color: white;
      }
    }
  }
}
</style>
